export default "__VITE_ASSET__C1r99cvT__"